
<!--<app-alerts></app-alerts>-->
<main>
  <section>
    <div class="container-fluid ptb-42">
      <div class="row">
        <div class="col-auto">
          <div class="titles-bdr-r">
            <h1 class="color-primary fs-325remTitles">{{ timetablesInfo.Titulo_Pagina }}</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container pb-120 gx-5 gx-lg-0 horariosPage">
      <!-- Filtros -->
      <div class="row justify-content-center mb-4 horariosFiltersBlock">
        <div class="col-lg-11 col-12 p-3 bg-secondary bdr-r-10 gx-5">
          <form [formGroup]="searchForm" *ngIf="searchForm">
            <div class="row">
              <div class="col-lg col-12">
                <label aria-label="Município" class="mb-1 color-white">{{'formLabels.municipio' | translate}}</label>
                <select aria-label="Selecionar Município" formControlName="municipality" class="form-select">
                  <option value="" disabled selected hidden>{{'formPlaceholders.selecionar' | translate}}</option>
                  <option *ngFor="let municipality of municipalities" value="{{municipality.code}}">{{municipality.name}}</option>
                </select>
              </div>
              <div class="col-lg col-12 mt-2 mt-lg-0 d-xl-block d-none">
                <label aria-label="Linha" class="mb-1 color-white">{{'formLabels.linha' | translate}}</label>
                <input formControlName="line" list="routeListOptions" id="routeList" class="form-control"
                       autocomplete="off" autocorrect="off" spellcheck="false"
                       placeholder="{{'formPlaceholders.selecionar' | translate}}"/>
                <datalist id="routeListOptions"></datalist>
              </div>
              <div class="col-lg col-12 mt-2 mt-lg-0 d-block d-xl-none">
                <label aria-label="Linha" class="mb-1 color-white">{{'formLabels.linha' | translate}}</label>
                <select aria-label="Selecionar Linha" formControlName="line" class="form-select">
                  <option value="" disabled selected hidden>{{'formPlaceholders.selecionar' | translate}}</option>
                  <option *ngFor="let route of routes" value="{{route.number}}">{{route.number}} - {{route.name}}</option>
                </select>
              </div>
            </div>
            <div class="row my-2">
              <div class="col-lg-3 col-12">
                <label aria-label="Sentido" class="mb-1 color-white">{{'formLabels.sentido' | translate}}</label>
                <select aria-label="Selecionar Sentido" formControlName="direction" class="form-select">
                  <option value="" disabled selected hidden>{{'formPlaceholders.selecionar' | translate}}</option>
                  <option value=0>{{'formPlaceholders.ida' | translate}}</option>
                  <option value=1>{{'formPlaceholders.volta' | translate}}</option>
                </select>
              </div>
              <div class="col-lg-3 col-12 mt-2 mt-lg-0">
                <label aria-label="Data" class="mb-1 color-white">{{'formLabels.data' | translate}}</label>
                <input formControlName="date" type="text" placeholder="Datepicker" class="form-control" bsDatepicker [bsValue]="bsValue"
                       [minDate]="minDate" [maxDate]="maxDate"
                       [bsConfig]="{ showWeekNumbers: false, dateInputFormat: 'DD-MM-YYYY', isAnimated: true, adaptivePosition: true }">
              </div>
              <div class="col-lg-auto col-12 ms-auto text-end align-content-end mt-3 mt-lg-0">
                <button (click)="onReset()" *ngIf="isFormAnyField()" title="Limpar Formulário" type="button" class="btn btn-link-white me-3"><p class="m-0 fw-600">{{'buttons.limpar' | translate}}<i class="uil uil-backspace fs-20px ms-2 color-white"></i></p></button>
                <button (click)="searchSchedules()" type="button" title="Mostrar Horários" class="btn btn-primary" [disabled]="!isFormValid()"><p class="m-0 fw-600">{{'buttons.mostrarHorario' | translate}}<i class="uil uil-arrow-up-right fs-20px ms-2 color-white"></i></p></button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- Alerts -->
      <div class="row justify-content-center mb-4" *ngIf="warningsListSize > 0 && warningsListShow.length > 0">
        <div class="col-lg-11 bg-yellow-soft bdr-r-10 p-4">
            <label aria-label="Alertas e Avisos" class="mb-1">{{ homeInfo.Avisos_Alertas }}</label>
            <div *ngFor="let group of warningsListShow; let i = index;" class="row alertsHomepageCollapse">
              <div class="col-12" *ngIf="i > 0">
                <hr class="hr-alerts-small">
              </div>
              <div class="col-auto align-self-center">
                <p class="fw-800 text-center mb-0">{{ group.Inicio }}</p>
              </div>
              <div class="col-12">
                <div class="accordion" [id]="'alertAccordion' + i">
                  <div class="mt-2" *ngFor="let warning of group.Avisos; let j= index;">
                    <div class="accordion-item">
                      <h2 class="accordion-header" [id]="'warning-' + i + '-' + j">
                        <button title="Botão Alertas" class="accordion-button collapsed" type="button"
                                data-bs-toggle="collapse"
                                [attr.data-bs-target]="'#warningText-' + i + '-' + j" aria-expanded="false">
                          <i *ngIf="warning.Tipo.TipoAlerta == 'Alerta'"
                             class="uil uil-exclamation-triangle color-warning me-2"></i>
                          <i *ngIf="warning.Tipo.TipoAlerta == 'Informativo'"
                             class="uil uil-info-circle color-info me-2"></i>
                          <i *ngIf="warning.Tipo.TipoAlerta == 'Obras'"
                             class="uil uil-traffic-barrier color-warning me-2"></i>
                          <span *ngIf="warning.Intervalo">{{ warning.Intervalo }} - </span>
                          {{ warning.Titulo }}
                        </button>
                      </h2>
                      <div [id]="'warningText-' + i + '-' + j" class="accordion-collapse collapse"
                           [attr.data-bs-parent]="'#alertAccordion' + i">
                        <div class="accordion-body">
                          <p class="mt-3 fs-14px" [innerHTML]="warning.Texto"></p>
                          <div class="mt-auto">
                            <p *ngIf="warning.Municipios && warning.Municipios.length > 0" class="mt-3">
                              <strong>Municípios: </strong>{{ warning.municipalities_string }}</p>
                            <p *ngIf="warning.Linhas && warning.Linhas.length > 0" class="mt-3"><strong>Linhas: </strong>{{ warning.Linhas }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
      <!-- Content -->
      <div [ngClass]="!searching && hasTimes ? 'row justify-content-center horariosInfoBlock min-h800' : 'row justify-content-center horariosInfoBlock'">
        <div id="routeMap" class="col-lg-11 bg-white bdr-r-10">
          <div [hidden]="!searching" class="row justify-content-center page-loading ptb-80"></div>
          <div [hidden]="searching || !hasTimes">
            <div class="row justify-content-between align-items-center py-4 px-4">
              <!-- Nome e Numero de Linha -->
              <div class="col-lg-9 col-12 id-linha">
                <div class="col-auto d-inline-flex">
                  <span class="badge uppercase-font fs-28px" [ngStyle]="{'background-color': routeColor}">{{ selectedRoute.number }}</span>
                </div>
                <div class="col-9 d-inline-flex">
                  <div class="d-inline-flex">
                    <i class="uil uil-angle-right-b fs-2rem"></i><h5 class="horarios-linhas-nomes">{{ selectedRoute.name }}</h5>
                  </div>
                </div>
              </div>
              <!-- Horário de Circulação -->
              <div *ngIf="hasTrips" class="col-lg-3 col-12 text-lg-end text-start pb-3 pb-lg-0">
                <form [formGroup]="tripForm" *ngIf="tripForm && hasTrips">
                  <label aria-label="Início Circulação" class="mb-1">{{'formLabels.inicioCirculacao' | translate}}</label>
                  <select aria-label="Selecionar Início Circulação" class="form-select" formControlName="start">
                    <option value="" disabled hidden>{{'formPlaceholders.hora' | translate}}</option>
                    <option *ngFor="let start of availableTrips" [value]="start.trip_id">{{ start.time_range }}</option>
                  </select>
                </form>
              </div>
              <!-- Download Button 
              <div class="col-12 d-inline-flex pt-3">
                <button title="Download PDF" type="button" class="btn btn-outline-secondary btn-download" aria-pressed="true" (click)="downloadPdf(selectedRoute.number)">
                  <p class="m-0 fs-12px fw-700 line-height-1-2">{{ 'buttons.downloadSchedule' | translate }}<i class="uil uil-file-download-alt fs-20px ms-2"></i></p>
                </button>
              </div> -->
              <div *ngIf="hasTrips && searchingTimetable" class="row justify-content-center page-loading ptb-80"></div>
            </div>
            <div [hidden]="!hasTimes || searchingTimetable" class="row justify-content-between px-4 p-frame-horarios">
              <div *ngIf="mapVisible" class="col-lg-8 col-12">
                <!-- Google Map -->
                <div class="pb-2 sticky-top sticky-top-40 map-wrapper">

                  <div [hidden]="true" class="map-switcher">
                    <button
                      (click)="changeStyle('streets')"
                      [class.active]="currentStyle === 'streets'">
                      {{'common.map' | translate}}
                    </button>
                    <button
                      (click)="changeStyle('satellite')"
                      [class.active]="currentStyle === 'satellite'">
                      {{'common.satellite' | translate}}
                    </button>
                  </div>

                  <mgl-map
                      [style.height]="'500px'"
                      [style.width]="'100%'"
                      [style]="mapStyle"
                      [minZoom]="8"
                      [center]="[-8.2261, 41.2069]"
                      (zoomEnd)="onZoomChanged()"
                      (mapLoad)="onMapLoad($event.target)"
                      [attributionControl]="false">

                    <!-- Selected stop -->
                    <mgl-marker
                      *ngIf="selectedStop"
                      [lngLat]="[selectedStop.lng, selectedStop.lat]"
                      [offset]="markerStyleSelected.offset"
                      [anchor]="'bottom'">

                      <div
                        class="marker-wrapper stop-marker"
                        style="z-index: 9999;"
                        [style.width]="markerStyleSelected.width"
                        [style.height]="markerStyleSelected.height">

                        <img
                          [src]="markerStyleSelected.src"
                          alt="stop"
                          class="marker-image">

                      </div>

                    </mgl-marker>


                    <ng-container *ngIf="lineReady && arrowIconReady">
                      <!-- Route -->
                      <mgl-geojson-source id="route-source" [data]="routeGeoJson"></mgl-geojson-source>

                      <mgl-layer
                        id="route-layer-background"
                        type="line"
                        source="route-source"
                        [paint]="{ 'line-color': '#000000', 'line-width': 6 }">
                      </mgl-layer>

                      <mgl-layer
                        id="route-layer-foreground"
                        type="line"
                        source="route-source"
                        [paint]="{ 'line-color': currentRouteColor, 'line-width': 2 }">
                      </mgl-layer>

                      <mgl-layer
                        id="route-arrows"
                        type="symbol"
                        source="route-source"
                        [layout]="{
                          'symbol-placement': 'line',
                          'symbol-spacing': 130,
                          'icon-image': 'arrow-icon',
                          'icon-size': 0.8,
                          'icon-allow-overlap': true,
                          'icon-ignore-placement': true,
                          'icon-rotation-alignment': 'map'
                        }">
                      </mgl-layer>

                      <!-- Start stop -->
                      <mgl-marker
                        [lngLat]="[firstScheduleStop.lng, firstScheduleStop.lat]"
                        [zIndex]="getMarkerStyle('start').zIndex">

                        <div
                          class="marker-wrapper"
                          (click)="selectStop(firstScheduleStop, true); $event.stopPropagation()"
                          [style.width]="getMarkerStyle('start').width"
                          [style.height]="getMarkerStyle('start').height">

                          <img
                            [src]="getMarkerStyle('start').src"
                            class="marker-image">

                        </div>

                      </mgl-marker>

                      <!-- End stop -->
                      <mgl-marker
                        [lngLat]="[lastScheduleStop.lng, lastScheduleStop.lat]"
                        [zIndex]="getMarkerStyle('end').zIndex">

                        <div
                          class="marker-wrapper"
                          (click)="selectStop(lastScheduleStop, true); $event.stopPropagation()"
                          [style.width]="getMarkerStyle('end').width"
                          [style.height]="getMarkerStyle('end').height">

                          <img
                            [src]="getMarkerStyle('end').src"
                            class="marker-image">

                        </div>

                      </mgl-marker>

                      <!-- Stops -->
                      <mgl-geojson-source id="points-source" [data]="pointsGeoJson"></mgl-geojson-source>

                      <mgl-layer
                      id="unclustered-point"
                      type="circle"
                      source="points-source"
                      [filter]="['!', ['has', 'point_count']]"
                      [paint]="{
                        'circle-color': [
                          'step', ['zoom'],
                          '#fff',
                          0, '#fff',
                          8, '#fff',
                          10, '#fff',
                          14, '#fff',
                          18, '#fff',
                          20, '#fff'
                        ],
                        'circle-radius': [
                          'interpolate', ['linear'], ['zoom'],
                          0, 1,
                          8, 1,
                          10, 4,
                          14, 5,
                          18, 10,
                          20, 7
                        ],
                        'circle-stroke-width': [
                          'interpolate', ['linear'], ['zoom'],
                          0, 0,
                          8, 1,
                          10, 2,
                          14, 3,
                          18, 4,
                          20, 7
                        ],
                        'circle-stroke-color': [
                          'step', ['zoom'],
                          '#00A609',
                          8, '#00A609',
                          10, '#00A609',
                          14, '#00A609',
                          18, '#00A609',
                          20, '#00A609',
                        ],
                      }"
                      (layerClick)="onPointClick($event)"
                      (layerMouseEnter)="cursorStyle = 'pointer'"
                      (layerMouseLeave)="cursorStyle = ''">
                    </mgl-layer>

                    </ng-container>
                  </mgl-map>
                  <!-- Schedule Table With Hours & Minuts -->
                  <div *ngIf="hasTimes && !hasTrips" class="mt-3 stopTimetable-container">
                    <p class="stopTimetable-p">{{ timetablesInfo.Aviso_Horarios }}</p>
                    <div class="stopTimetable-content">
                      <div class="stopTimetable-col">
                        <div class="stopTimetable-hour fw-800">{{'common.horas' | translate}}</div>
                        <div class="stopTimetable-minutesLines fw-800">{{'common.minutos' | translate}}</div>
                      </div>
                      <div *ngFor="let item of scheduleArray" class="stopTimetable-col">
                        <div class="stopTimetable-hour">{{ item.hour }}</div>
                        <div *ngFor="let minute of item.minutes" class="stopTimetable-minutesLines">{{ minute }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- No trips available -->
              <div *ngIf="hasTimes && !hasTrips" class="col-lg-4 col-12 pt-100 pt-lg-0">
                <div>
                  <ol class="stops-list">
                    <li *ngFor="let stop of scheduleStops"
                        (click)="selectStop(stop, false)"
                        [ngClass]="{'active-stop': selectedStop?.id === stop.id, 'inactive-stop': selectedStop?.id !== stop.id}"
                        [id]="stop.id">
                      <a><p class="mini-stop-tag">{{ stop['zone'] }}</p>{{ stop['name'] }}</a>
                    </li>
                  </ol>
                </div>
              </div>
              <!-- With trips availalbe -->
              <div *ngIf="hasTrips" class="col-lg-4 col-12">
                <div>
                  <ol class="stops-list">
                    <li *ngFor="let stop of scheduleStops"
                        (click)="selectStop(stop, false)"
                        [ngClass]="{'active-stop': selectedStop?.id === stop.id, 'inactive-stop': selectedStop?.id !== stop.id}"
                        [id]="stop.id">
                      <a *ngFor="let hour of getHours(stop.schedule)">
                        <p class="mini-stop-tag">{{ hour }}:<span
                          *ngFor="let minute of stop.schedule[hour]">{{ minute }}</span></p>{{ stop['zone'] }} - {{ stop['name'] }}
                      </a>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="noTimetable" class="my-4">
            <div class="row justify-content-between align-items-center py-4 px-4">
              <div class="col-lg-9 col-12 id-linha">
                <div class="col-auto d-inline-flex">
                  <span class="badge uppercase-font fs-28px m-2" [ngStyle]="{'background-color': routeColor}">{{ selectedRoute.number }}</span>
                </div>
                <div class="col-9 d-inline-flex">
                  <div class="d-inline-flex">
                    <i class="uil uil-angle-right-b fs-2rem"></i><h5 class="horarios-linhas-nomes">{{ selectedRoute.name }}</h5>
                  </div>
                </div>
              </div>

              <!-- Download Button 
              <div class="col-12 d-inline-flex pt-0 pt-lg-3">
                <button title="Download PDF" type="button" class="btn btn-outline-secondary btn-download" aria-pressed="true" (click)="downloadPdf(selectedRoute.number)">
                  <p class="m-0 fs-12px fw-700 line-height-1-2">{{ 'buttons.downloadSchedule' | translate }}<i class="uil uil-file-download-alt fs-20px ms-2"></i></p>
                </button>
              </div>-->

            </div>
            <div class="noResultsText py-4">
              {{'stops.naoFoiPossivelApresentarHorarios' | translate}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

